module.exports = "/static/media/logo-phone-by-webcom.2b1ac2c8.svg";